import React from 'react';

import {
  TRenderErrorBoundaryProps,
  TRenderErrorBoundaryState,
} from '@/shared/components/ui/render-error-boundary/render-error-boundary.types';

// A class because only error boundaries catch render errors; hooks cannot.
export class RenderErrorBoundary extends React.Component<
  TRenderErrorBoundaryProps,
  TRenderErrorBoundaryState
> {
  state: TRenderErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): TRenderErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    this.props.onError?.(error);
  }

  componentDidUpdate(prevProps: TRenderErrorBoundaryProps) {
    if (prevProps.children !== this.props.children && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}
